import { calcRem } from './calcRem'
import { Breakpoints, theme } from '../theme'

export function breakpointMax(size: Breakpoints) {
    return `@media (max-width: ${calcRem(theme.breakpoints[size] - 1)})`
}

export default breakpointMax
